<template>
  <div id="mycollectionfileTable">
    <el-upload ref="gentlyUpload" style="height: 0;" :action="actionUrl" :headers="Token" :show-file-list="false"
      :accept="accept" :on-error="handleError" :before-upload="handleBeforeUpload" :on-success="handleAvatarSuccess"
      :file-list="fileList">
      <el-button id="gentlyBtn" size="small" style="display:none;">
        轻量化
      </el-button>
    </el-upload>

    <el-table ref="multipleTable" :data="list" tooltip-effect="dark" empty-text="" height="100%" border class="tableCol"
      @row-click="clickRow" @selection-change="selectChange">
      <template slot="empty">
        <img :src="zanwu" alt="" />
        <p style="font-size:16px;color:#000;">
          暂无数据
        </p>
      </template>
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column width="50" align="center">
        <template slot-scope="{ row }">
          <div style="display:flex;align-items: center;justify-content: flex-end">
            <!-- 收藏图标 -->
            <span v-if="row.isFavorite === 1" style="cursor:pointer;" @click.stop="delCol(row)">
              <img :src="shoucang" alt="" style="margin-right: 12px;margin-top: 4px;" />
            </span>
            <span v-if="row.isFavorite !== 1" style="cursor:pointer;" @click.stop="collectFile(row)">
              <img :src="weishoucang" alt="" style="margin-right: 12px;margin-top: 4px;" />
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column ref="fileNameSort" :key="16" show-overflow-tooltip align="left" label="文件名称" prop="folderName"
        width="">
        <template slot-scope="{ row }">
          <div style="display:flex;align-items: center" class="colCheck">
            <!-- 轻量化图标 -->
            <fileLightFlag :row="row" @updateLight="updateLight" />

            <!-- 文件的图标 -->
            <img :src="className(row)" style="flex-shrink:0;margin:0 5px;margin-left:6px;" />
            <!-- 文件名称 -->
            <div :style="{ cursor: cacheListContent.createFolder.folderId === 'recycle'? '' : 'pointer',}" @click.stop="clickFolderFile(row, $event)">
              <span style="width:80%;">{{ row.folderName }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column :key="1" align="center" label="路径" prop="favoriteName" width="230" show-overflow-tooltip>
      </el-table-column>
      <el-table-column :key="15" align="center" label="操作" width="260">
        <template slot-scope="scope">
          <div class="more">
            <i v-if="downMydoc" class="el el-icon-download rowIcon" title="下载"
              @click.stop="downloadFile(scope.row)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column :key="7" align="center" label="收藏时间" prop="operDate" width="230" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <share v-if="isShowShare" :type="3" @click-event="cancelSelect"></share>
  </div>
</template>

<script>
import { mapState } from "vuex";
import share from "@/CommonDP/components/documentRelevant/shareFile.vue";
import { filePreviewV1, tableRowIcon } from "@/CommonDP/utils/docPublic";
import docService from "@/CommonDP/service/doc-service";
import { downloadUrltoken, gentlyUrl, downloadFile } from "@/CommonDP/utils";
import { getToken } from "@/CommonDP/utils";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  components: { share, fileLightFlag },
  data() {
    return {
      downMydoc: checkPermission(this.$allPerms.MYCOLLECTION_DOWN),
      cacheListContent: {
        createFolder: {}
      },
      Token: {
        Token: getToken()
      },
      actionUrl: "",
      accept: "",
      qinglianghuaList: [],
      fileList: [],
      list: [],
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      shoucang: require("@/CommonDP/assets/shoucang.png"),
      weishoucang: require("@/CommonDP/assets/weishoucang.png")
    };
  },
  computed: {
    ...mapState({
      isShowShare: state => state.XtDesign.isShowShare,
      enterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo
    })
  },
  created() {
    this.querlist2();
    this.$store.dispatch("XtDesignUpdateSelect", []);
  },
  methods: {
    cancelSelect() {
      this.$refs.multipleTable.clearSelection();
    },
    async querlist2() {
      try {
        const pageNum = 1;
        const pageSize = 999;
        const enterpriseId = this.enterpriseId;
        const result = await docService.queryPersonFavorite(pageSize, pageNum, enterpriseId);
        if (result.result === "0") {
          for (let i = 0; i < result.data.length; i++) {
            result.data[i].colCheck = 1;
            result.data[i].isFavorite = 1;
          }
          this.list = result.data;
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    async querlist4(data) {
      try {
        const result = await docService.querySearchFolder(data);
        if (result.result === "0") {
          this.list = result.data;
        }
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: true,
          message: e.message || "加载失败"
        });
      }
    },
    // 取消收藏
    delCol(val) {
      this.$store.dispatch("perFileUpdateMessageObj", {
        isShow: true,
        message: "取消收藏中..."
      });
      const param = {
        folderId: val.folderId,
        folderName: val.folderName,
        isFolder: val.isFolder,
        prjId: this.enterpriseId
      };
      docService.deletePersonFavorite(param).then(res => {
        if (res.result === "0") {
          this.$store.dispatch("perFileUpdateNodeList");
          this.$message.success("取消收藏成功");
          this.querlist2();
          this.$store.dispatch("perFileUpdateMessageObj", {
            isShow: false,
            message: ""
          });
        }
      });
    },
    // 收藏
    collectFile(val) {
      this.$store.dispatch("perFileUpdateMessageObj", {
        isShow: true,
        message: "收藏中..."
      });
      const param = {
        folderId: val.folderId,
        folderName: val.folderName,
        isFolder: val.isFolder,
        prjId: "",
        enterpriseId: this.enterpriseId
      };
      docService.addPersonFavorite(param).then(res => {
        if (res.result == "0") {
          this.$store.dispatch("perFileUpdateNodeList");
          this.$message.success("收藏成功");
          this.querlist2();
          this.$store.dispatch("perFileUpdateMessageObj", {
            isShow: false,
            message: ""
          });
        }
      });
    },

    // 点击文件名称
    async clickFolderFile(row, event) {
      const { isFolder, prjId } = row;
      // isFolder === 1 是文件夹
      if (isFolder === 1) {
        // 只能转 一个级别 不能多个级别
        if (prjId === "MyDoc") {
          // 我的文档
          try {
            const result = await docService.navbar(1, row.folderId);
            if (result.result === "0") {
              this.$store.dispatch("perFileUpdateNavDan", result.data);
              this.$store.dispatch("perFileUpdateTreeNodeDan", row);
              this.$router.push({ name: "mydoc" });
            }
          } catch (e) {
            console.log(e);
          }
        } else if (prjId === "EnterprisePublic") {
          // console.log('公共资料');
          try {
            const result = await docService.navbar(1, row.folderId);
            if (result.result === "0") {
              this.$store.dispatch("perFileUpdateNavFen", result.data);
              this.$store.dispatch("perFileUpdateTreeNodeFen", row);
              this.$router.push({ name: "publicinformation" });
            }
          } catch (e) {
            console.log(e);
          }
        } else if (prjId === "EnterpriseShare") {
          try {
            const result = await docService.navbar(1, row.folderId);
            if (result.result === "0") {
              this.$store.dispatch("perFileUpdateNavFen", result.data);
              this.$store.dispatch("perFileUpdateTreeNodeFen", row);
              this.$router.push({ name: "sharinformation" });
            }
          } catch (e) {
            console.log(e);
          }
        } else if (prjId === "EnterpriseDeptDoc") {
          try {
            const result = await docService.navbarEnterpriseDept(1, row.folderId);
            if (result.result === "0") {
              this.$store.dispatch("perFileUpdateNavDan", result.data);
              this.$store.dispatch("perFileUpdateTreeNodeDan", row);
              const names = result.data[0].folderId;
              this.$router.push({ name: names });
            }
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        if (isFolder === 1) {
          return;
        } else if (row.isDelete === 1) {
          this.$message.warning("该文件已删除，无法查看");
        } else {
          this.viewFile(row, event);
        }
      }
    },

    async viewFile(row, event) {
      this.onLineView(row);
    },

    async onLineView(row) {
      const { status, folderId: fileId, fileVersion: versionId, parentId, fileType } = row;
      const data = {
        status, fileId, versionId, parentId, fileType
      };
      filePreviewV1(data, this.list);
    },

    async downloadFile(row) {
      const userInfo = this.userInfo;
      const { userId, token } = userInfo;
      if (row.isDelete === 1) {
        this.$message.warning("该文件已删除，无法下载");
      } else {
        const prjId = "MyDoc";
        if (row.isFolder !== 1) {
          const fileId = row.folderId;
          const version = row.fileVersion;
          const downzipurl = downloadUrltoken(prjId, fileId, version);
          downloadFile(downzipurl);
        } else {
          var params = {
            folderId: row.folderId,
            rootDirectory: row.folderName,
            prjId: prjId,
            enterpriseId: this.enterpriseId,
            userId: userId
          };
          console.log(params);
          docService.downloadfolder(params).then(response => {
            const fileName = row.folderName + ".zip";
            if ("msSaveOrOpenBlob" in navigator) {
              // 兼容ie
              // var blob = response
              window.navigator.msSaveOrOpenBlob(response, fileName);
              return;
            } else {
              const link = document.createElement("a");
              const blob = response;
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              link.setAttribute("download", decodeURI(fileName));
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          });
        }
      }
    },

    updateLight(row, type) {
      const prjId = this.enterpriseId;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.folderId, row.fileVersion)
        .then(res => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
        });
    },

    handleBeforeUpload(file) {
      const lastObj = this.qinglianghuaList[this.qinglianghuaList.length - 1];
      const uploadFileName = this._splitFileName(file.name);
      const rvtFileName = this._splitFileName(lastObj.folderName);
      if (uploadFileName !== rvtFileName) {
        this.$message({
          message: `请选择和${lastObj.fileType === 7 ? "rvt" : "skp"}文件匹配的轻量化文件`,
          type: "warning",
          duration: 2000,
          showClose: true
        });
        return false;
      }
      lastObj.status = "1";
      this.$message.success("操作成功,正在轻量化");
    },

    _splitFileName(text) {
      const pattern = /\.{1}[a-zA-Z]{1,}$/;
      if (pattern.exec(text) !== null) {
        return text.slice(0, pattern.exec(text).index);
      } else {
        return text;
      }
    },

    handleAvatarSuccess(response, file, fileList) {
      let status;
      let message;
      let type;
      if (response.data.code === 0) {
        status = "2";
        message = "文件轻量化成功";
        type = "success";
      } else {
        status = "";
        message = response.data.msg || "轻量化失败,请重新轻量化";
        type = "warning";
      }
      const rvtId = response.data.rvtId;
      const obj = this.qinglianghuaList.find(item => item.folderId === rvtId);
      obj.status = status;
      this.$message({
        message: message,
        type: type,
        duration: 2000,
        showClose: true
      });
      const index = this.qinglianghuaList.findIndex(item => item.folderId === rvtId);
      if (index > -1) {
        this.qinglianghuaList.splice(index, 1);
      }
    },

    handleError() {
      this.$message({
        message: "文件轻量化失败,请重新轻量化",
        type: "warning",
        duration: 2000,
        showClose: true
      });
    },

    async gently(scope) {
      const { row } = scope;
      this.qinglianghuaList.push(row);
      if (row.fileType === 7) {
        this.accept = ".bimex";
      } else {
        this.accept = ".bimex,.usdp";
      }
      const prjId = this.enterpriseId;
      const rvtId = row.folderId;
      const rvtVersion = row.fileVersion;
      this.actionUrl = gentlyUrl(rvtId, prjId, rvtVersion);
      this.$nextTick(() => {
        const gentlyBtn = document.getElementById("gentlyBtn");
        if (gentlyBtn) {
          gentlyBtn.click();
        }
      });
    },
    async deleteRow(row) {
      const folderId = row.folderId;
      try {
        this.$confirm("确定删除吗?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(async () => {
            this.$store.dispatch("perFileUpdateMessageObj", {
              isShow: true,
              message: "删除中..."
            });
            const result = await docService.queryDeleteFile([folderId]);
            if (result.result === "0") {
              this.querlist2();
              this.$store.dispatch("perFileUpdateMessageObj", {
                isShow: false,
                message: ""
              });
              this.$message({ type: "success", message: "删除成功" });
            }
          })
          .catch(() => {});
      } catch (e) {
        this.$store.dispatch("perFileUpdateMessageObj", {
          isShow: false,
          message: ""
        });
      }
    },

    isFinalGently(row) {
      return row.fileType === 7 || row.fileType === 18 || row.fileType === 19;
    },

    clickRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },

    selectChange(selection) {
      this.$store.dispatch("XtDesignUpdateSelect", selection);
    },

    className(row) {
      return tableRowIcon(row);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#mycollectionfileTable {
  width: 100%;
  height: 1px;
  flex-grow: 1;
  padding: var(--middle-space) var(--big-space);

  /deep/ .el-table {
    .el-table__body-wrapper {
      .rowIcon {
        cursor: pointer;
        color: #A1C5E7;
        font-size: 16px;
      }
    }

    .el-table__body-wrapper::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-track {
      background: rgb(255, 255, 255);
      border-radius: 2px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background: #eee;
      border-radius: 10px;
    }

    .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background: #C4C6CC;
    }
  }
}
</style>
